const getSNAdata = async (simulationId) => {
  const res = {
    data: [
      {
        "Unnamed: 0": 0,
        communication_type: "",
        conversation_id: "",
        duration: 1.3199999999999932,
        end_time: 441.99,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 440.67,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 1,
        communication_type: "",
        conversation_id: "",
        duration: 6.329999999999984,
        end_time: 452.34,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 446.01,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 2,
        communication_type: "",
        conversation_id: "",
        duration: 8.310000000000002,
        end_time: 455.7,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 447.39,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 3,
        communication_type: "",
        conversation_id: "",
        duration: 0.839999999999975,
        end_time: 459.75,
        initiator: "relative",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 458.91,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 4,
        communication_type: "",
        conversation_id: "",
        duration: 4.170000000000016,
        end_time: 466.23,
        initiator: "red",
        location: "",
        receiver: "relative",
        stage_based_on_num_of_student: "",
        start_time: 462.06,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 5,
        communication_type: "",
        conversation_id: "",
        duration: 3.180000000000007,
        end_time: 465.93,
        initiator: "relative",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 462.75,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 6,
        communication_type: "",
        conversation_id: "",
        duration: 6.03000000000003,
        end_time: 476.79,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 470.76,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 7,
        communication_type: "",
        conversation_id: "",
        duration: 2.4599999999999795,
        end_time: 476.64,
        initiator: "relative",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 474.18,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 8,
        communication_type: "",
        conversation_id: "",
        duration: 0.75,
        end_time: 482.34,
        initiator: "red",
        location: "",
        receiver: "relative",
        stage_based_on_num_of_student: "",
        start_time: 481.59,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 9,
        communication_type: "",
        conversation_id: "",
        duration: 4.70999999999998,
        end_time: 488.7,
        initiator: "relative",
        location: "",
        receiver: "doctor,red",
        stage_based_on_num_of_student: "",
        start_time: 483.99,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 10,
        communication_type: "",
        conversation_id: "",
        duration: 5.970000000000027,
        end_time: 492.48,
        initiator: "red",
        location: "",
        receiver: "relative",
        stage_based_on_num_of_student: "",
        start_time: 486.51,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 11,
        communication_type: "",
        conversation_id: "",
        duration: 1.8899999999999864,
        end_time: 495.21,
        initiator: "relative",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 493.32,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 12,
        communication_type: "",
        conversation_id: "",
        duration: 2.490000000000009,
        end_time: 506.43,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 503.94,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 13,
        communication_type: "",
        conversation_id: "",
        duration: 2.3700000000000045,
        end_time: 512.13,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 509.76,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 14,
        communication_type: "",
        conversation_id: "",
        duration: 0.5699999999999932,
        end_time: 510.39,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 509.82,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 15,
        communication_type: "",
        conversation_id: "",
        duration: 0.3600000000000136,
        end_time: 515.79,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 515.43,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 16,
        communication_type: "",
        conversation_id: "",
        duration: 1.1999999999999318,
        end_time: 521.28,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 520.08,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 17,
        communication_type: "",
        conversation_id: "",
        duration: 1.5,
        end_time: 526.65,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 525.15,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 18,
        communication_type: "",
        conversation_id: "",
        duration: 0.3899999999999863,
        end_time: 526.14,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 525.75,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 19,
        communication_type: "",
        conversation_id: "",
        duration: 0.6599999999999682,
        end_time: 536.13,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 535.47,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 20,
        communication_type: "",
        conversation_id: "",
        duration: 3,
        end_time: 544.26,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 541.26,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 21,
        communication_type: "",
        conversation_id: "",
        duration: 1.5299999999999727,
        end_time: 544.23,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 542.7,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 22,
        communication_type: "",
        conversation_id: "",
        duration: 2.8199999999999363,
        end_time: 550.89,
        initiator: "red",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 548.07,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 23,
        communication_type: "",
        conversation_id: "",
        duration: 3.0300000000000864,
        end_time: 552.96,
        initiator: "relative",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 549.93,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 24,
        communication_type: "",
        conversation_id: "",
        duration: 0.6000000000000227,
        end_time: 554.88,
        initiator: "red",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 554.28,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 25,
        communication_type: "",
        conversation_id: "",
        duration: 10.889999999999986,
        end_time: 572.55,
        initiator: "red",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 561.66,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 26,
        communication_type: "",
        conversation_id: "",
        duration: 2.9699999999999136,
        end_time: 565.29,
        initiator: "yellow",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 562.32,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 27,
        communication_type: "",
        conversation_id: "",
        duration: 0.3899999999999863,
        end_time: 564.87,
        initiator: "relative",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 564.48,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 28,
        communication_type: "",
        conversation_id: "",
        duration: 1.740000000000009,
        end_time: 572.49,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 570.75,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 29,
        communication_type: "",
        conversation_id: "",
        duration: 0.6899999999999409,
        end_time: 577.77,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 577.08,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 30,
        communication_type: "",
        conversation_id: "",
        duration: 21.659999999999968,
        end_time: 598.89,
        initiator: "green",
        location: "",
        receiver: "yellow",
        stage_based_on_num_of_student: "",
        start_time: 577.23,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 31,
        communication_type: "",
        conversation_id: "",
        duration: 4.5,
        end_time: 582.45,
        initiator: "yellow",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 577.95,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 32,
        communication_type: "",
        conversation_id: "",
        duration: 4.589999999999918,
        end_time: 582.66,
        initiator: "red",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 578.07,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 33,
        communication_type: "",
        conversation_id: "",
        duration: 2.25,
        end_time: 583.44,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 581.19,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 34,
        communication_type: "",
        conversation_id: "",
        duration: 66.30000000000007,
        end_time: 653.46,
        initiator: "red",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 587.16,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 35,
        communication_type: "",
        conversation_id: "",
        duration: 0.5099999999999909,
        end_time: 592.71,
        initiator: "yellow",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 592.2,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 36,
        communication_type: "",
        conversation_id: "",
        duration: 5.759999999999991,
        end_time: 599.28,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 593.52,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 37,
        communication_type: "",
        conversation_id: "",
        duration: 0.5399999999999636,
        end_time: 601.38,
        initiator: "yellow",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 600.84,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 38,
        communication_type: "",
        conversation_id: "",
        duration: 16.649999999999977,
        end_time: 618.66,
        initiator: "green",
        location: "",
        receiver: "yellow,red",
        stage_based_on_num_of_student: "",
        start_time: 602.01,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 39,
        communication_type: "",
        conversation_id: "",
        duration: 37.47000000000003,
        end_time: 641.28,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 603.81,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 40,
        communication_type: "",
        conversation_id: "",
        duration: 0.4200000000000727,
        end_time: 607.32,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 606.9,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 41,
        communication_type: "",
        conversation_id: "",
        duration: 6.600000000000023,
        end_time: 617.52,
        initiator: "yellow",
        location: "",
        receiver: "green,red",
        stage_based_on_num_of_student: "",
        start_time: 610.92,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 42,
        communication_type: "",
        conversation_id: "",
        duration: 6.210000000000036,
        end_time: 618.45,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 612.24,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 43,
        communication_type: "",
        conversation_id: "",
        duration: 0.4800000000000182,
        end_time: 622.62,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 622.14,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 44,
        communication_type: "",
        conversation_id: "",
        duration: 3.300000000000068,
        end_time: 628.47,
        initiator: "green",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 625.17,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 45,
        communication_type: "",
        conversation_id: "",
        duration: 3.7200000000000273,
        end_time: 634.26,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 630.54,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 46,
        communication_type: "",
        conversation_id: "",
        duration: 18.840000000000032,
        end_time: 651.21,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 632.37,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 47,
        communication_type: "",
        conversation_id: "",
        duration: 12.090000000000032,
        end_time: 651.21,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 639.12,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 48,
        communication_type: "",
        conversation_id: "",
        duration: 9.81000000000006,
        end_time: 653.1,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 643.29,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 49,
        communication_type: "",
        conversation_id: "",
        duration: 23.07000000000005,
        end_time: 668.94,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 645.87,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 50,
        communication_type: "",
        conversation_id: "",
        duration: 3.7799999999999727,
        end_time: 658.74,
        initiator: "green",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 654.96,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 51,
        communication_type: "",
        conversation_id: "",
        duration: 38.75999999999999,
        end_time: 695.64,
        initiator: "red",
        location: "",
        receiver: "yellow",
        stage_based_on_num_of_student: "",
        start_time: 656.88,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 52,
        communication_type: "",
        conversation_id: "",
        duration: 1.4700000000000273,
        end_time: 658.77,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 657.3,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 53,
        communication_type: "",
        conversation_id: "",
        duration: 1.740000000000009,
        end_time: 659.7,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 657.96,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 54,
        communication_type: "",
        conversation_id: "",
        duration: 11.819999999999936,
        end_time: 673.68,
        initiator: "green",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 661.86,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 55,
        communication_type: "",
        conversation_id: "",
        duration: 16.680000000000064,
        end_time: 681.96,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 665.28,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 56,
        communication_type: "",
        conversation_id: "",
        duration: 3.3899999999999864,
        end_time: 670.26,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 666.87,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 57,
        communication_type: "",
        conversation_id: "",
        duration: 2.939999999999941,
        end_time: 676.38,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 673.44,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 58,
        communication_type: "",
        conversation_id: "",
        duration: 12.659999999999968,
        end_time: 689.91,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 677.25,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 59,
        communication_type: "",
        conversation_id: "",
        duration: 5.3700000000000045,
        end_time: 684.69,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 679.32,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 60,
        communication_type: "",
        conversation_id: "",
        duration: 8.730000000000018,
        end_time: 696.51,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 687.78,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 61,
        communication_type: "",
        conversation_id: "",
        duration: 12,
        end_time: 702.66,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 690.66,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 62,
        communication_type: "",
        conversation_id: "",
        duration: 2.0400000000000773,
        end_time: 695.1,
        initiator: "green",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 693.06,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 63,
        communication_type: "",
        conversation_id: "",
        duration: 2.8500000000000227,
        end_time: 696.78,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 693.93,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 64,
        communication_type: "",
        conversation_id: "",
        duration: 6.209999999999923,
        end_time: 706.53,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 700.32,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 65,
        communication_type: "",
        conversation_id: "",
        duration: 18.360000000000014,
        end_time: 719.22,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 700.86,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 66,
        communication_type: "",
        conversation_id: "",
        duration: 5.069999999999936,
        end_time: 706.89,
        initiator: "green",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 701.82,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 67,
        communication_type: "",
        conversation_id: "",
        duration: 2.2799999999999727,
        end_time: 710.55,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 708.27,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 68,
        communication_type: "",
        conversation_id: "",
        duration: 1.32000000000005,
        end_time: 711.48,
        initiator: "green",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 710.16,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 69,
        communication_type: "",
        conversation_id: "",
        duration: 18.06000000000006,
        end_time: 730.98,
        initiator: "red",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 712.92,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 70,
        communication_type: "",
        conversation_id: "",
        duration: 9.149999999999975,
        end_time: 727.59,
        initiator: "green",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 718.44,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 71,
        communication_type: "",
        conversation_id: "",
        duration: 0.5399999999999636,
        end_time: 721.29,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 720.75,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 72,
        communication_type: "",
        conversation_id: "",
        duration: 62.49000000000001,
        end_time: 786.87,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 724.38,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 73,
        communication_type: "",
        conversation_id: "",
        duration: 4.289999999999964,
        end_time: 729.18,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 724.89,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 74,
        communication_type: "",
        conversation_id: "",
        duration: 4.050000000000068,
        end_time: 736.95,
        initiator: "green",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 732.9,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 75,
        communication_type: "",
        conversation_id: "",
        duration: 7.2000000000000455,
        end_time: 741.63,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 734.43,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 76,
        communication_type: "",
        conversation_id: "",
        duration: 30.569999999999936,
        end_time: 765.39,
        initiator: "red",
        location: "",
        receiver: "yellow",
        stage_based_on_num_of_student: "",
        start_time: 734.82,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 77,
        communication_type: "",
        conversation_id: "",
        duration: 0.5399999999999636,
        end_time: 740.31,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 739.77,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 78,
        communication_type: "",
        conversation_id: "",
        duration: 1.949999999999932,
        end_time: 742.02,
        initiator: "green",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 740.07,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 79,
        communication_type: "",
        conversation_id: "",
        duration: 0.7799999999999727,
        end_time: 750.51,
        initiator: "relative",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 749.73,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 80,
        communication_type: "",
        conversation_id: "",
        duration: 3.57000000000005,
        end_time: 757.44,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 753.87,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 81,
        communication_type: "",
        conversation_id: "",
        duration: 3.4200000000000728,
        end_time: 757.32,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 753.9,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 82,
        communication_type: "",
        conversation_id: "",
        duration: 0.3300000000000409,
        end_time: 755.1,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 754.77,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 83,
        communication_type: "",
        conversation_id: "",
        duration: 1.8899999999999864,
        end_time: 763.02,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 761.13,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 84,
        communication_type: "",
        conversation_id: "",
        duration: 0.6600000000000819,
        end_time: 763.08,
        initiator: "relative",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 762.42,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 85,
        communication_type: "",
        conversation_id: "",
        duration: 3.75,
        end_time: 767.49,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 763.74,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 86,
        communication_type: "",
        conversation_id: "",
        duration: 2.6399999999999864,
        end_time: 772.23,
        initiator: "red",
        location: "",
        receiver: "yellow",
        stage_based_on_num_of_student: "",
        start_time: 769.59,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 87,
        communication_type: "",
        conversation_id: "",
        duration: 7.650000000000091,
        end_time: 779.94,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 772.29,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 88,
        communication_type: "",
        conversation_id: "",
        duration: 0.3600000000000136,
        end_time: 779.67,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 779.31,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 89,
        communication_type: "",
        conversation_id: "",
        duration: 0.5699999999999363,
        end_time: 783.54,
        initiator: "yellow",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 782.97,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 90,
        communication_type: "",
        conversation_id: "",
        duration: 0.4499999999999318,
        end_time: 783.93,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 783.48,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 91,
        communication_type: "",
        conversation_id: "",
        duration: 0.6900000000000546,
        end_time: 787.5,
        initiator: "yellow",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 786.81,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 92,
        communication_type: "",
        conversation_id: "",
        duration: 6.720000000000027,
        end_time: 796.35,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 789.63,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 93,
        communication_type: "",
        conversation_id: "",
        duration: 4.740000000000009,
        end_time: 794.88,
        initiator: "green",
        location: "",
        receiver: "yellow,relative,doctor",
        stage_based_on_num_of_student: "",
        start_time: 790.14,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 94,
        communication_type: "",
        conversation_id: "",
        duration: 8.370000000000005,
        end_time: 799.5,
        initiator: "relative",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 791.13,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 95,
        communication_type: "",
        conversation_id: "",
        duration: 38.63999999999999,
        end_time: 833.61,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 794.97,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 96,
        communication_type: "",
        conversation_id: "",
        duration: 16.290000000000077,
        end_time: 812.85,
        initiator: "doctor",
        location: "",
        receiver: "green,relative",
        stage_based_on_num_of_student: "",
        start_time: 796.56,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 97,
        communication_type: "",
        conversation_id: "",
        duration: 5.639999999999986,
        end_time: 803.91,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 798.27,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 98,
        communication_type: "",
        conversation_id: "",
        duration: 0.6899999999999409,
        end_time: 801.42,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 800.73,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 99,
        communication_type: "",
        conversation_id: "",
        duration: 0.3300000000000409,
        end_time: 802.23,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 801.9,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 100,
        communication_type: "",
        conversation_id: "",
        duration: 14.129999999999995,
        end_time: 822.18,
        initiator: "green",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 808.05,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 101,
        communication_type: "",
        conversation_id: "",
        duration: 1.259999999999991,
        end_time: 810.51,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 809.25,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 102,
        communication_type: "",
        conversation_id: "",
        duration: 2.8199999999999363,
        end_time: 815.43,
        initiator: "relative",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 812.61,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 103,
        communication_type: "",
        conversation_id: "",
        duration: 6.779999999999973,
        end_time: 820.53,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 813.75,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 104,
        communication_type: "",
        conversation_id: "",
        duration: 1.8899999999999864,
        end_time: 824.01,
        initiator: "relative",
        location: "",
        receiver: "blue",
        stage_based_on_num_of_student: "",
        start_time: 822.12,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 105,
        communication_type: "",
        conversation_id: "",
        duration: 7.980000000000018,
        end_time: 832.32,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 824.34,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 107,
        communication_type: "",
        conversation_id: "",
        duration: 1.589999999999918,
        end_time: 829.17,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 827.58,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 106,
        communication_type: "",
        conversation_id: "",
        duration: 1.7999999999999543,
        end_time: 829.38,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 827.58,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 108,
        communication_type: "",
        conversation_id: "",
        duration: 1.5599999999999454,
        end_time: 829.17,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 827.61,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 109,
        communication_type: "",
        conversation_id: "",
        duration: 10.740000000000007,
        end_time: 838.35,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 827.61,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 110,
        communication_type: "",
        conversation_id: "",
        duration: 1.0199999999999818,
        end_time: 842.4,
        initiator: "green",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 841.38,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 111,
        communication_type: "",
        conversation_id: "",
        duration: 38.940000000000055,
        end_time: 883.74,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 844.8,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 112,
        communication_type: "",
        conversation_id: "",
        duration: 27,
        end_time: 872.67,
        initiator: "green",
        location: "",
        receiver: "relative",
        stage_based_on_num_of_student: "",
        start_time: 845.67,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 113,
        communication_type: "",
        conversation_id: "",
        duration: 0.5399999999999636,
        end_time: 852.24,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 851.7,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 114,
        communication_type: "",
        conversation_id: "",
        duration: 0.4500000000000455,
        end_time: 852.99,
        initiator: "relative",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 852.54,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 115,
        communication_type: "",
        conversation_id: "",
        duration: 0.3300000000000409,
        end_time: 864.12,
        initiator: "relative",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 863.79,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 116,
        communication_type: "",
        conversation_id: "",
        duration: 0.3599999999998999,
        end_time: 864.18,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 863.82,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 117,
        communication_type: "",
        conversation_id: "",
        duration: 3.1200000000000045,
        end_time: 880.41,
        initiator: "doctor",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 877.29,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 118,
        communication_type: "",
        conversation_id: "",
        duration: 12.659999999999968,
        end_time: 890.28,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 877.62,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 119,
        communication_type: "",
        conversation_id: "",
        duration: 10.979999999999905,
        end_time: 898.68,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 887.7,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 120,
        communication_type: "",
        conversation_id: "",
        duration: 1.2299999999999045,
        end_time: 889.56,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 888.33,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 121,
        communication_type: "",
        conversation_id: "",
        duration: 21.57000000000005,
        end_time: 914.73,
        initiator: "doctor",
        location: "",
        receiver: "green,relative",
        stage_based_on_num_of_student: "",
        start_time: 893.16,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 122,
        communication_type: "",
        conversation_id: "",
        duration: 1.5900000000000318,
        end_time: 897.12,
        initiator: "green",
        location: "",
        receiver: "relative,doctor",
        stage_based_on_num_of_student: "",
        start_time: 895.53,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 123,
        communication_type: "",
        conversation_id: "",
        duration: 10.709999999999924,
        end_time: 907.68,
        initiator: "relative",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 896.97,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 124,
        communication_type: "",
        conversation_id: "",
        duration: 1.6200000000000043,
        end_time: 899.79,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 898.17,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 125,
        communication_type: "",
        conversation_id: "",
        duration: 0.5399999999999636,
        end_time: 903.99,
        initiator: "green",
        location: "",
        receiver: "relative,doctor,blue",
        stage_based_on_num_of_student: "",
        start_time: 903.45,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 126,
        communication_type: "",
        conversation_id: "",
        duration: 0.6300000000001091,
        end_time: 905.94,
        initiator: "blue",
        location: "",
        receiver: "relative",
        stage_based_on_num_of_student: "",
        start_time: 905.31,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 127,
        communication_type: "",
        conversation_id: "",
        duration: 4.2299999999999045,
        end_time: 912.06,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 907.83,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 128,
        communication_type: "",
        conversation_id: "",
        duration: 67.32000000000005,
        end_time: 976.71,
        initiator: "blue",
        location: "",
        receiver: "green,doctor",
        stage_based_on_num_of_student: "",
        start_time: 909.39,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 129,
        communication_type: "",
        conversation_id: "",
        duration: 0.599999999999909,
        end_time: 910.05,
        initiator: "green",
        location: "",
        receiver: "relative,doctor",
        stage_based_on_num_of_student: "",
        start_time: 909.45,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 130,
        communication_type: "",
        conversation_id: "",
        duration: 0.8999999999999773,
        end_time: 913.98,
        initiator: "green",
        location: "",
        receiver: "doctor,blue",
        stage_based_on_num_of_student: "",
        start_time: 913.08,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 131,
        communication_type: "",
        conversation_id: "",
        duration: 5.009999999999991,
        end_time: 923.61,
        initiator: "green",
        location: "",
        receiver: "yellow,relative,doctor",
        stage_based_on_num_of_student: "",
        start_time: 918.6,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 132,
        communication_type: "",
        conversation_id: "",
        duration: 0.8400000000000318,
        end_time: 919.86,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 919.02,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 133,
        communication_type: "",
        conversation_id: "",
        duration: 0.5399999999999636,
        end_time: 920.73,
        initiator: "relative",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 920.19,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 134,
        communication_type: "",
        conversation_id: "",
        duration: 0.5099999999999909,
        end_time: 920.76,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 920.25,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 135,
        communication_type: "",
        conversation_id: "",
        duration: 0.5099999999999909,
        end_time: 921.42,
        initiator: "yellow",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 920.91,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 136,
        communication_type: "",
        conversation_id: "",
        duration: 3.92999999999995,
        end_time: 930.12,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 926.19,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 137,
        communication_type: "",
        conversation_id: "",
        duration: 49.91999999999996,
        end_time: 977.13,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 927.21,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 138,
        communication_type: "",
        conversation_id: "",
        duration: 9.480000000000018,
        end_time: 936.75,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 927.27,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 139,
        communication_type: "",
        conversation_id: "",
        duration: 0.4500000000000455,
        end_time: 933,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 932.55,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 140,
        communication_type: "",
        conversation_id: "",
        duration: 7.919999999999959,
        end_time: 942.81,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 934.89,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 141,
        communication_type: "",
        conversation_id: "",
        duration: 0.3299999999999272,
        end_time: 937.65,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 937.32,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 142,
        communication_type: "",
        conversation_id: "",
        duration: 1.259999999999991,
        end_time: 943.71,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 942.45,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 143,
        communication_type: "",
        conversation_id: "",
        duration: 17.40000000000009,
        end_time: 962.46,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 945.06,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 144,
        communication_type: "",
        conversation_id: "",
        duration: 0.4500000000000455,
        end_time: 947.19,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 946.74,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 145,
        communication_type: "",
        conversation_id: "",
        duration: 2.6399999999999864,
        end_time: 952.35,
        initiator: "doctor",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 949.71,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 146,
        communication_type: "",
        conversation_id: "",
        duration: 1.1100000000000136,
        end_time: 952.74,
        initiator: "yellow",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 951.63,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 147,
        communication_type: "",
        conversation_id: "",
        duration: 9.059999999999944,
        end_time: 966.15,
        initiator: "doctor",
        location: "",
        receiver: "green,blue",
        stage_based_on_num_of_student: "",
        start_time: 957.09,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 148,
        communication_type: "",
        conversation_id: "",
        duration: 1.4400000000000546,
        end_time: 959.22,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 957.78,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 149,
        communication_type: "",
        conversation_id: "",
        duration: 1.6200000000000043,
        end_time: 960.84,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 959.22,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 150,
        communication_type: "",
        conversation_id: "",
        duration: 0.8999999999999773,
        end_time: 969.15,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 968.25,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 151,
        communication_type: "",
        conversation_id: "",
        duration: 0.5099999999999909,
        end_time: 970.74,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 970.23,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 152,
        communication_type: "",
        conversation_id: "",
        duration: 4.199999999999932,
        end_time: 982.53,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 978.33,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 153,
        communication_type: "",
        conversation_id: "",
        duration: 13.410000000000082,
        end_time: 994.08,
        initiator: "green",
        location: "",
        receiver: "relative,doctor",
        stage_based_on_num_of_student: "",
        start_time: 980.67,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 154,
        communication_type: "",
        conversation_id: "",
        duration: 20.93999999999994,
        end_time: 1002.18,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 981.24,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 155,
        communication_type: "",
        conversation_id: "",
        duration: 8.039999999999964,
        end_time: 992.61,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 984.57,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 156,
        communication_type: "",
        conversation_id: "",
        duration: 2.6399999999999864,
        end_time: 989.31,
        initiator: "relative",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 986.67,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 157,
        communication_type: "",
        conversation_id: "",
        duration: 1.3799999999999957,
        end_time: 999.39,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 998.01,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 158,
        communication_type: "",
        conversation_id: "",
        duration: 0.4800000000000182,
        end_time: 998.58,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 998.1,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 159,
        communication_type: "",
        conversation_id: "",
        duration: 13.32000000000005,
        end_time: 1012.71,
        initiator: "green",
        location: "",
        receiver: "relative,doctor",
        stage_based_on_num_of_student: "",
        start_time: 999.39,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 160,
        communication_type: "",
        conversation_id: "",
        duration: 15.089999999999918,
        end_time: 1017.54,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1002.45,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 161,
        communication_type: "",
        conversation_id: "",
        duration: 2.6399999999999864,
        end_time: 1005.15,
        initiator: "relative",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1002.51,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 162,
        communication_type: "",
        conversation_id: "",
        duration: 12.690000000000056,
        end_time: 1018.32,
        initiator: "blue",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1005.63,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 163,
        communication_type: "",
        conversation_id: "",
        duration: 8.400000000000091,
        end_time: 1018.32,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1009.92,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 164,
        communication_type: "",
        conversation_id: "",
        duration: 0.4800000000000182,
        end_time: 1011.96,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1011.48,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 165,
        communication_type: "",
        conversation_id: "",
        duration: 0.3899999999999863,
        end_time: 1011.87,
        initiator: "relative",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1011.48,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 166,
        communication_type: "",
        conversation_id: "",
        duration: 24.81000000000006,
        end_time: 1040.7,
        initiator: "green",
        location: "",
        receiver: "doctor,blue",
        stage_based_on_num_of_student: "",
        start_time: 1015.89,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 167,
        communication_type: "",
        conversation_id: "",
        duration: 13.709999999999924,
        end_time: 1035.12,
        initiator: "blue",
        location: "",
        receiver: "green,doctor",
        stage_based_on_num_of_student: "",
        start_time: 1021.41,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 168,
        communication_type: "",
        conversation_id: "",
        duration: 9.090000000000032,
        end_time: 1031.43,
        initiator: "doctor",
        location: "",
        receiver: "green,blue",
        stage_based_on_num_of_student: "",
        start_time: 1022.34,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 169,
        communication_type: "",
        conversation_id: "",
        duration: 2.700000000000045,
        end_time: 1032.51,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1029.81,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 170,
        communication_type: "",
        conversation_id: "",
        duration: 0.959999999999809,
        end_time: 1034.34,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1033.38,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 171,
        communication_type: "",
        conversation_id: "",
        duration: 0.5699999999999363,
        end_time: 1037.76,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1037.19,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 172,
        communication_type: "",
        conversation_id: "",
        duration: 0.2999999999999545,
        end_time: 1039.02,
        initiator: "blue",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1038.72,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 173,
        communication_type: "",
        conversation_id: "",
        duration: 17.670000000000073,
        end_time: 1062.21,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1044.54,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 174,
        communication_type: "",
        conversation_id: "",
        duration: 21.99000000000001,
        end_time: 1066.83,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1044.84,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 175,
        communication_type: "",
        conversation_id: "",
        duration: 1.259999999999991,
        end_time: 1046.49,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1045.23,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 176,
        communication_type: "",
        conversation_id: "",
        duration: 0.7199999999997999,
        end_time: 1046.85,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1046.13,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 177,
        communication_type: "",
        conversation_id: "",
        duration: 0.6299999999998818,
        end_time: 1051.8,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1051.17,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 178,
        communication_type: "",
        conversation_id: "",
        duration: 3.1799999999998363,
        end_time: 1055.58,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1052.4,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 179,
        communication_type: "",
        conversation_id: "",
        duration: 6.659999999999855,
        end_time: 1063.8,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1057.14,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 180,
        communication_type: "",
        conversation_id: "",
        duration: 0.6300000000001091,
        end_time: 1061.94,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1061.31,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 181,
        communication_type: "",
        conversation_id: "",
        duration: 0.5100000000002183,
        end_time: 1061.88,
        initiator: "yellow",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1061.37,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 182,
        communication_type: "",
        conversation_id: "",
        duration: 3.4200000000000728,
        end_time: 1068.63,
        initiator: "green",
        location: "",
        receiver: "yellow,relative,doctor",
        stage_based_on_num_of_student: "",
        start_time: 1065.21,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 183,
        communication_type: "",
        conversation_id: "",
        duration: 5.159999999999855,
        end_time: 1072.11,
        initiator: "doctor",
        location: "",
        receiver: "green,blue",
        stage_based_on_num_of_student: "",
        start_time: 1066.95,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 184,
        communication_type: "",
        conversation_id: "",
        duration: 0.3600000000001273,
        end_time: 1070.94,
        initiator: "red",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1070.58,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 185,
        communication_type: "",
        conversation_id: "",
        duration: 0.6299999999998818,
        end_time: 1071.87,
        initiator: "yellow",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1071.24,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 186,
        communication_type: "",
        conversation_id: "",
        duration: 37.13999999999987,
        end_time: 1109.28,
        initiator: "green",
        location: "",
        receiver: "yellow,relative,doctor,red",
        stage_based_on_num_of_student: "",
        start_time: 1072.14,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 187,
        communication_type: "",
        conversation_id: "",
        duration: 1.6499999999998636,
        end_time: 1074.09,
        initiator: "blue",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1072.44,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 188,
        communication_type: "",
        conversation_id: "",
        duration: 27.299999999999955,
        end_time: 1107.03,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1079.73,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 189,
        communication_type: "",
        conversation_id: "",
        duration: 2.099999999999909,
        end_time: 1084.53,
        initiator: "red",
        location: "",
        receiver: "green,blue",
        stage_based_on_num_of_student: "",
        start_time: 1082.43,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 190,
        communication_type: "",
        conversation_id: "",
        duration: 2.2799999999999727,
        end_time: 1085.91,
        initiator: "doctor",
        location: "",
        receiver: "green,blue",
        stage_based_on_num_of_student: "",
        start_time: 1083.63,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 191,
        communication_type: "",
        conversation_id: "",
        duration: 13.620000000000118,
        end_time: 1100.91,
        initiator: "relative",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1087.29,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 192,
        communication_type: "",
        conversation_id: "",
        duration: 2.430000000000064,
        end_time: 1090.38,
        initiator: "red",
        location: "",
        receiver: "green,yellow",
        stage_based_on_num_of_student: "",
        start_time: 1087.95,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 193,
        communication_type: "",
        conversation_id: "",
        duration: 0.3600000000001273,
        end_time: 1088.7,
        initiator: "yellow",
        location: "",
        receiver: "green,red",
        stage_based_on_num_of_student: "",
        start_time: 1088.34,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 194,
        communication_type: "",
        conversation_id: "",
        duration: 0.599999999999909,
        end_time: 1090.26,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1089.66,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 195,
        communication_type: "",
        conversation_id: "",
        duration: 1.2000000000000457,
        end_time: 1095.45,
        initiator: "yellow",
        location: "",
        receiver: "green,red",
        stage_based_on_num_of_student: "",
        start_time: 1094.25,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 196,
        communication_type: "",
        conversation_id: "",
        duration: 1.8300000000001544,
        end_time: 1097.4,
        initiator: "red",
        location: "",
        receiver: "green,yellow",
        stage_based_on_num_of_student: "",
        start_time: 1095.57,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 197,
        communication_type: "",
        conversation_id: "",
        duration: 4.710000000000036,
        end_time: 1100.94,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1096.23,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 198,
        communication_type: "",
        conversation_id: "",
        duration: 5.819999999999936,
        end_time: 1107.03,
        initiator: "red",
        location: "",
        receiver: "yellow,doctor",
        stage_based_on_num_of_student: "",
        start_time: 1101.21,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 199,
        communication_type: "",
        conversation_id: "",
        duration: 2.009999999999991,
        end_time: 1106.25,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 1104.24,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 200,
        communication_type: "",
        conversation_id: "",
        duration: 0.6300000000001091,
        end_time: 1104.96,
        initiator: "relative",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1104.33,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 201,
        communication_type: "",
        conversation_id: "",
        duration: 13.829999999999927,
        end_time: 1120.29,
        initiator: "doctor",
        location: "",
        receiver: "green,blue",
        stage_based_on_num_of_student: "",
        start_time: 1106.46,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 202,
        communication_type: "",
        conversation_id: "",
        duration: 6.269999999999982,
        end_time: 1117.35,
        initiator: "relative",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1111.08,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 203,
        communication_type: "",
        conversation_id: "",
        duration: 5.6099999999999,
        end_time: 1119.78,
        initiator: "green",
        location: "",
        receiver: "relative,doctor,red",
        stage_based_on_num_of_student: "",
        start_time: 1114.17,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 204,
        communication_type: "",
        conversation_id: "",
        duration: 4.019999999999982,
        end_time: 1120.44,
        initiator: "red",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1116.42,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 205,
        communication_type: "",
        conversation_id: "",
        duration: 1.4700000000000273,
        end_time: 1119.09,
        initiator: "blue",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1117.62,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 206,
        communication_type: "",
        conversation_id: "",
        duration: 8.519999999999982,
        end_time: 1131.09,
        initiator: "blue",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1122.57,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 207,
        communication_type: "",
        conversation_id: "",
        duration: 5.369999999999891,
        end_time: 1129.11,
        initiator: "red",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1123.74,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 208,
        communication_type: "",
        conversation_id: "",
        duration: 10.980000000000018,
        end_time: 1135.71,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1124.73,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 209,
        communication_type: "",
        conversation_id: "",
        duration: 7.799999999999954,
        end_time: 1133.82,
        initiator: "doctor",
        location: "",
        receiver: "green,blue",
        stage_based_on_num_of_student: "",
        start_time: 1126.02,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 210,
        communication_type: "",
        conversation_id: "",
        duration: 8.759999999999991,
        end_time: 1138.2,
        initiator: "relative",
        location: "",
        receiver: "green,blue",
        stage_based_on_num_of_student: "",
        start_time: 1129.44,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 211,
        communication_type: "",
        conversation_id: "",
        duration: 1.740000000000009,
        end_time: 1133.22,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 1131.48,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 212,
        communication_type: "",
        conversation_id: "",
        duration: 86.12999999999988,
        end_time: 1219.35,
        initiator: "red",
        location: "",
        receiver: "yellow",
        stage_based_on_num_of_student: "",
        start_time: 1133.22,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 213,
        communication_type: "",
        conversation_id: "",
        duration: 81.44999999999982,
        end_time: 1218.33,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1136.88,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 214,
        communication_type: "",
        conversation_id: "",
        duration: 11.13000000000011,
        end_time: 1149.99,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1138.86,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 215,
        communication_type: "",
        conversation_id: "",
        duration: 0.8399999999999181,
        end_time: 1139.76,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1138.92,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 216,
        communication_type: "",
        conversation_id: "",
        duration: 5.910000000000082,
        end_time: 1148.49,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 1142.58,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 217,
        communication_type: "",
        conversation_id: "",
        duration: 15.210000000000036,
        end_time: 1159.05,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1143.84,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 218,
        communication_type: "",
        conversation_id: "",
        duration: 8.490000000000009,
        end_time: 1161.66,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 1153.17,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 219,
        communication_type: "",
        conversation_id: "",
        duration: 11.279999999999973,
        end_time: 1164.54,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1153.26,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 220,
        communication_type: "",
        conversation_id: "",
        duration: 1.410000000000082,
        end_time: 1155.69,
        initiator: "blue",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1154.28,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 221,
        communication_type: "",
        conversation_id: "",
        duration: 11.36999999999989,
        end_time: 1170.06,
        initiator: "blue",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1158.69,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 222,
        communication_type: "",
        conversation_id: "",
        duration: 17.00999999999999,
        end_time: 1179.51,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1162.5,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 223,
        communication_type: "",
        conversation_id: "",
        duration: 3.6299999999998818,
        end_time: 1169.82,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1166.19,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 224,
        communication_type: "",
        conversation_id: "",
        duration: 7.410000000000082,
        end_time: 1175.46,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1168.05,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 225,
        communication_type: "",
        conversation_id: "",
        duration: 4.739999999999782,
        end_time: 1178.37,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 1173.63,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 226,
        communication_type: "",
        conversation_id: "",
        duration: 18.779999999999973,
        end_time: 1194.18,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1175.4,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 227,
        communication_type: "",
        conversation_id: "",
        duration: 0.4200000000000727,
        end_time: 1186.17,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 1185.75,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 228,
        communication_type: "",
        conversation_id: "",
        duration: 9.660000000000082,
        end_time: 1196.88,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1187.22,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 229,
        communication_type: "",
        conversation_id: "",
        duration: 2.4600000000000364,
        end_time: 1193.19,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 1190.73,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 230,
        communication_type: "",
        conversation_id: "",
        duration: 9.75,
        end_time: 1207.08,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1197.33,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 231,
        communication_type: "",
        conversation_id: "",
        duration: 0.7200000000000273,
        end_time: 1203.33,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1202.61,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 232,
        communication_type: "",
        conversation_id: "",
        duration: 1.259999999999991,
        end_time: 1204.77,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 1203.51,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 233,
        communication_type: "",
        conversation_id: "",
        duration: 0.9299999999998364,
        end_time: 1209.57,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1208.64,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 234,
        communication_type: "",
        conversation_id: "",
        duration: 5.130000000000109,
        end_time: 1216.41,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1211.28,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 235,
        communication_type: "",
        conversation_id: "",
        duration: 1.800000000000182,
        end_time: 1218.42,
        initiator: "relative",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1216.62,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 236,
        communication_type: "",
        conversation_id: "",
        duration: 15.720000000000027,
        end_time: 1232.49,
        initiator: "green",
        location: "",
        receiver: "relative,doctor",
        stage_based_on_num_of_student: "",
        start_time: 1216.77,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 237,
        communication_type: "",
        conversation_id: "",
        duration: 14.909999999999854,
        end_time: 1233.84,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 1218.93,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 238,
        communication_type: "",
        conversation_id: "",
        duration: 53.22000000000003,
        end_time: 1275.03,
        initiator: "doctor",
        location: "",
        receiver: "green,blue",
        stage_based_on_num_of_student: "",
        start_time: 1221.81,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 239,
        communication_type: "",
        conversation_id: "",
        duration: 42.72000000000003,
        end_time: 1265.19,
        initiator: "red",
        location: "",
        receiver: "yellow",
        stage_based_on_num_of_student: "",
        start_time: 1222.47,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 240,
        communication_type: "",
        conversation_id: "",
        duration: 9.779999999999973,
        end_time: 1233.18,
        initiator: "blue",
        location: "",
        receiver: "relative",
        stage_based_on_num_of_student: "",
        start_time: 1223.4,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 241,
        communication_type: "",
        conversation_id: "",
        duration: 4.980000000000018,
        end_time: 1228.8,
        initiator: "relative",
        location: "",
        receiver: "green,blue",
        stage_based_on_num_of_student: "",
        start_time: 1223.82,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 242,
        communication_type: "",
        conversation_id: "",
        duration: 2.700000000000045,
        end_time: 1238.91,
        initiator: "blue",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1236.21,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 243,
        communication_type: "",
        conversation_id: "",
        duration: 8.940000000000055,
        end_time: 1246.2,
        initiator: "green",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1237.26,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 244,
        communication_type: "",
        conversation_id: "",
        duration: 0.5699999999999363,
        end_time: 1243.2,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1242.63,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 245,
        communication_type: "",
        conversation_id: "",
        duration: 1.1699999999998454,
        end_time: 1245.12,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 1243.95,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 246,
        communication_type: "",
        conversation_id: "",
        duration: 23.189999999999827,
        end_time: 1270.11,
        initiator: "blue",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1246.92,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 247,
        communication_type: "",
        conversation_id: "",
        duration: 33.840000000000146,
        end_time: 1284.21,
        initiator: "green",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1250.37,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 248,
        communication_type: "",
        conversation_id: "",
        duration: 2.189999999999827,
        end_time: 1252.83,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 1250.64,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 249,
        communication_type: "",
        conversation_id: "",
        duration: 21.029999999999973,
        end_time: 1281.09,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 1260.06,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 250,
        communication_type: "",
        conversation_id: "",
        duration: 7.170000000000073,
        end_time: 1278.27,
        initiator: "red",
        location: "",
        receiver: "yellow",
        stage_based_on_num_of_student: "",
        start_time: 1271.1,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 251,
        communication_type: "",
        conversation_id: "",
        duration: 0.3299999999999272,
        end_time: 1271.76,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1271.43,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 252,
        communication_type: "",
        conversation_id: "",
        duration: 21.86999999999989,
        end_time: 1295.61,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1273.74,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 253,
        communication_type: "",
        conversation_id: "",
        duration: 16.950000000000045,
        end_time: 1296.15,
        initiator: "doctor",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1279.2,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 254,
        communication_type: "",
        conversation_id: "",
        duration: 0.7799999999999727,
        end_time: 1280.04,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1279.26,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 255,
        communication_type: "",
        conversation_id: "",
        duration: 4.169999999999845,
        end_time: 1285.56,
        initiator: "red",
        location: "",
        receiver: "yellow",
        stage_based_on_num_of_student: "",
        start_time: 1281.39,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 256,
        communication_type: "",
        conversation_id: "",
        duration: 3.059999999999945,
        end_time: 1290.6,
        initiator: "green",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1287.54,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 257,
        communication_type: "",
        conversation_id: "",
        duration: 3.450000000000045,
        end_time: 1292.52,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 1289.07,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 258,
        communication_type: "",
        conversation_id: "",
        duration: 28.67999999999984,
        end_time: 1317.84,
        initiator: "red",
        location: "",
        receiver: "yellow",
        stage_based_on_num_of_student: "",
        start_time: 1289.16,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 259,
        communication_type: "",
        conversation_id: "",
        duration: 39.08999999999992,
        end_time: 1332.99,
        initiator: "green",
        location: "",
        receiver: "relative,doctor",
        stage_based_on_num_of_student: "",
        start_time: 1293.9,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 260,
        communication_type: "",
        conversation_id: "",
        duration: 2.400000000000091,
        end_time: 1301.52,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1299.12,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 261,
        communication_type: "",
        conversation_id: "",
        duration: 20.430000000000064,
        end_time: 1321.17,
        initiator: "doctor",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1300.74,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 262,
        communication_type: "",
        conversation_id: "",
        duration: 2.849999999999909,
        end_time: 1303.62,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1300.77,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 263,
        communication_type: "",
        conversation_id: "",
        duration: 4.0499999999999545,
        end_time: 1312.47,
        initiator: "blue",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1308.42,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 264,
        communication_type: "",
        conversation_id: "",
        duration: 1.8599999999999,
        end_time: 1311.24,
        initiator: "relative",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1309.38,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 265,
        communication_type: "",
        conversation_id: "",
        duration: 1.7999999999999543,
        end_time: 1313.58,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1311.78,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 266,
        communication_type: "",
        conversation_id: "",
        duration: 2.9099999999998545,
        end_time: 1317.54,
        initiator: "relative",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1314.63,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 267,
        communication_type: "",
        conversation_id: "",
        duration: 0.5099999999999909,
        end_time: 1317.33,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 1316.82,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 268,
        communication_type: "",
        conversation_id: "",
        duration: 9.509999999999993,
        end_time: 1326.9,
        initiator: "blue",
        location: "",
        receiver: "green",
        stage_based_on_num_of_student: "",
        start_time: 1317.39,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 269,
        communication_type: "",
        conversation_id: "",
        duration: 24.08999999999992,
        end_time: 1345.74,
        initiator: "relative",
        location: "",
        receiver: "green,blue",
        stage_based_on_num_of_student: "",
        start_time: 1321.65,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 270,
        communication_type: "",
        conversation_id: "",
        duration: 53.54999999999996,
        end_time: 1378.02,
        initiator: "doctor",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1324.47,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 271,
        communication_type: "",
        conversation_id: "",
        duration: 10.529999999999973,
        end_time: 1342.83,
        initiator: "blue",
        location: "",
        receiver: "relative,red",
        stage_based_on_num_of_student: "",
        start_time: 1332.3,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 272,
        communication_type: "",
        conversation_id: "",
        duration: 1.589999999999918,
        end_time: 1334.76,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1333.17,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 273,
        communication_type: "",
        conversation_id: "",
        duration: 28.65000000000009,
        end_time: 1361.91,
        initiator: "red",
        location: "",
        receiver: "yellow",
        stage_based_on_num_of_student: "",
        start_time: 1333.26,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 274,
        communication_type: "",
        conversation_id: "",
        duration: 3.240000000000009,
        end_time: 1339.41,
        initiator: "green",
        location: "",
        receiver: "relative,blue",
        stage_based_on_num_of_student: "",
        start_time: 1336.17,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 275,
        communication_type: "",
        conversation_id: "",
        duration: 9.029999999999973,
        end_time: 1348.59,
        initiator: "yellow",
        location: "",
        receiver: "red",
        stage_based_on_num_of_student: "",
        start_time: 1339.56,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 276,
        communication_type: "",
        conversation_id: "",
        duration: 0.4500000000000455,
        end_time: 1346.4,
        initiator: "blue",
        location: "",
        receiver: "green,relative",
        stage_based_on_num_of_student: "",
        start_time: 1345.95,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 277,
        communication_type: "",
        conversation_id: "",
        duration: 1.259999999999991,
        end_time: 1348.74,
        initiator: "green",
        location: "",
        receiver: "relative,blue",
        stage_based_on_num_of_student: "",
        start_time: 1347.48,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 278,
        communication_type: "",
        conversation_id: "",
        duration: 26.13000000000011,
        end_time: 1374.99,
        initiator: "relative",
        location: "",
        receiver: "green,red,blue",
        stage_based_on_num_of_student: "",
        start_time: 1348.86,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 279,
        communication_type: "",
        conversation_id: "",
        duration: 6.269999999999982,
        end_time: 1358.01,
        initiator: "green",
        location: "",
        receiver: "relative,red",
        stage_based_on_num_of_student: "",
        start_time: 1351.74,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 280,
        communication_type: "",
        conversation_id: "",
        duration: 0.7799999999999727,
        end_time: 1355.76,
        initiator: "yellow",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1354.98,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 281,
        communication_type: "",
        conversation_id: "",
        duration: 3.690000000000055,
        end_time: 1364.19,
        initiator: "blue",
        location: "",
        receiver: "relative",
        stage_based_on_num_of_student: "",
        start_time: 1360.5,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 282,
        communication_type: "",
        conversation_id: "",
        duration: 1.1700000000000728,
        end_time: 1362.72,
        initiator: "yellow",
        location: "",
        receiver: "doctor",
        stage_based_on_num_of_student: "",
        start_time: 1361.55,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 283,
        communication_type: "",
        conversation_id: "",
        duration: 20.430000000000064,
        end_time: 1384.02,
        initiator: "green",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1363.59,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 284,
        communication_type: "",
        conversation_id: "",
        duration: 15.870000000000118,
        end_time: 1384.65,
        initiator: "blue",
        location: "",
        receiver: "green,relative",
        stage_based_on_num_of_student: "",
        start_time: 1368.78,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 285,
        communication_type: "",
        conversation_id: "",
        duration: 3.209999999999809,
        end_time: 1377.12,
        initiator: "red",
        location: "",
        receiver: "relative",
        stage_based_on_num_of_student: "",
        start_time: 1373.91,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 286,
        communication_type: "",
        conversation_id: "",
        duration: 1.2300000000000182,
        end_time: 1383.33,
        initiator: "relative",
        location: "",
        receiver: "patient",
        stage_based_on_num_of_student: "",
        start_time: 1382.1,
        text: "",
        utterance_id: "",
      },
      {
        "Unnamed: 0": 287,
        communication_type: "",
        conversation_id: "",
        duration: 1.5,
        end_time: 1384.32,
        initiator: "red",
        location: "",
        receiver: "relative",
        stage_based_on_num_of_student: "",
        start_time: 1382.82,
        text: "",
        utterance_id: "",
      },
    ],
    status: 200,
    statusText: "OK",
    headers: {
      "content-length": "71980",
      "content-type": "application/json",
    },
    config: {
      transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false,
      },
      transformRequest: [null],
      transformResponse: [null],
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      env: {
        FormData: null,
      },
      headers: {
        "Access-Control-Allow-Origin": "http://localhost",
      },
      baseURL: "http://localhost:5003",
      method: "get",
      url: "/get_data?sessionId=417",
    },
    request: {},
  };

  return res;
};

const getENAdata = async (body) => {
  const { simulationId, startTime, endTime } = body;

  // Hard coded data for session 350
  const allResponse = `{
    "data": {
        "acknowledging": {
            "acknowledging": 0,
            "call-out": 122,
            "escalation": 6,
            "handover": 30,
            "questioning": 86,
            "task allocation": 102
        },
        "call-out": {
            "acknowledging": 122,
            "call-out": 0,
            "escalation": 6,
            "handover": 29,
            "questioning": 77,
            "task allocation": 87
        },
        "escalation": {
            "acknowledging": 6,
            "call-out": 6,
            "escalation": 0,
            "handover": 3,
            "questioning": 2,
            "task allocation": 5
        },
        "handover": {
            "acknowledging": 30,
            "call-out": 29,
            "escalation": 3,
            "handover": 0,
            "questioning": 11,
            "task allocation": 19
        },
        "questioning": {
            "acknowledging": 86,
            "call-out": 77,
            "escalation": 2,
            "handover": 11,
            "questioning": 0,
            "task allocation": 69
        },
        "task allocation": {
            "acknowledging": 102,
            "call-out": 87,
            "escalation": 5,
            "handover": 19,
            "questioning": 69,
            "task allocation": 0
        }
    },
    "status": 200,
    "statusText": "OK",
    "headers": {
        "content-length": "763",
        "content-type": "application/json"
    },
    "config": {
        "transitional": {
            "silentJSONParsing": true,
            "forcedJSONParsing": true,
            "clarifyTimeoutError": false
        },
        "transformRequest": [
            null
        ],
        "transformResponse": [
            null
        ],
        "timeout": 0,
        "xsrfCookieName": "XSRF-TOKEN",
        "xsrfHeaderName": "X-XSRF-TOKEN",
        "maxContentLength": -1,
        "maxBodyLength": -1,
        "env": {
            "FormData": null
        },
        "headers": {
            "Access-Control-Allow-Origin": "http://localhost"
        },
        "baseURL": "http://localhost:5003",
        "method": "get",
        "url": "/get_ena_data?sessionId=417&start=0&end=1391"
    },
    "request": {}
}`;
  const scnStartedResponse = `{
    "data": {
        "acknowledging": {
            "acknowledging": 0,
            "call-out": 0,
            "escalation": 0,
            "handover": 0,
            "questioning": 0,
            "task allocation": 0
        },
        "call-out": {
            "acknowledging": 0,
            "call-out": 0,
            "escalation": 0,
            "handover": 0,
            "questioning": 0,
            "task allocation": 0
        },
        "escalation": {
            "acknowledging": 0,
            "call-out": 0,
            "escalation": 0,
            "handover": 0,
            "questioning": 0,
            "task allocation": 0
        },
        "handover": {
            "acknowledging": 0,
            "call-out": 0,
            "escalation": 0,
            "handover": 0,
            "questioning": 0,
            "task allocation": 0
        },
        "questioning": {
            "acknowledging": 0,
            "call-out": 0,
            "escalation": 0,
            "handover": 0,
            "questioning": 0,
            "task allocation": 0
        },
        "task allocation": {
            "acknowledging": 0,
            "call-out": 0,
            "escalation": 0,
            "handover": 0,
            "questioning": 0,
            "task allocation": 0
        }
    },
    "status": 200,
    "statusText": "OK",
    "headers": {
        "content-length": "739",
        "content-type": "application/json"
    },
    "config": {
        "transitional": {
            "silentJSONParsing": true,
            "forcedJSONParsing": true,
            "clarifyTimeoutError": false
        },
        "transformRequest": [
            null
        ],
        "transformResponse": [
            null
        ],
        "timeout": 0,
        "xsrfCookieName": "XSRF-TOKEN",
        "xsrfHeaderName": "X-XSRF-TOKEN",
        "maxContentLength": -1,
        "maxBodyLength": -1,
        "env": {
            "FormData": null
        },
        "headers": {
            "Access-Control-Allow-Origin": "http://localhost"
        },
        "baseURL": "http://localhost:5003",
        "method": "get",
        "url": "/get_ena_data?sessionId=417&start=190&end=431"
    },
    "request": {}
}`;
  const handoverResponse = `{
    "data": {
        "acknowledging": {
            "acknowledging": 0,
            "call-out": 0,
            "escalation": 0,
            "handover": 0,
            "questioning": 0,
            "task allocation": 0
        },
        "call-out": {
            "acknowledging": 0,
            "call-out": 0,
            "escalation": 0,
            "handover": 0,
            "questioning": 0,
            "task allocation": 0
        },
        "escalation": {
            "acknowledging": 0,
            "call-out": 0,
            "escalation": 0,
            "handover": 0,
            "questioning": 0,
            "task allocation": 0
        },
        "handover": {
            "acknowledging": 0,
            "call-out": 0,
            "escalation": 0,
            "handover": 0,
            "questioning": 0,
            "task allocation": 0
        },
        "questioning": {
            "acknowledging": 0,
            "call-out": 0,
            "escalation": 0,
            "handover": 0,
            "questioning": 0,
            "task allocation": 0
        },
        "task allocation": {
            "acknowledging": 0,
            "call-out": 0,
            "escalation": 0,
            "handover": 0,
            "questioning": 0,
            "task allocation": 0
        }
    },
    "status": 200,
    "statusText": "OK",
    "headers": {
        "content-length": "739",
        "content-type": "application/json"
    },
    "config": {
        "transitional": {
            "silentJSONParsing": true,
            "forcedJSONParsing": true,
            "clarifyTimeoutError": false
        },
        "transformRequest": [
            null
        ],
        "transformResponse": [
            null
        ],
        "timeout": 0,
        "xsrfCookieName": "XSRF-TOKEN",
        "xsrfHeaderName": "X-XSRF-TOKEN",
        "maxContentLength": -1,
        "maxBodyLength": -1,
        "env": {
            "FormData": null
        },
        "headers": {
            "Access-Control-Allow-Origin": "http://localhost"
        },
        "baseURL": "http://localhost:5003",
        "method": "get",
        "url": "/get_ena_data?sessionId=417&start=431&end=562"
    },
    "request": {}
}`;
  const secondaryResponse = `{
    "data": {
        "acknowledging": {
            "acknowledging": 0,
            "call-out": 30,
            "escalation": 3,
            "handover": 13,
            "questioning": 18,
            "task allocation": 24
        },
        "call-out": {
            "acknowledging": 30,
            "call-out": 0,
            "escalation": 3,
            "handover": 12,
            "questioning": 17,
            "task allocation": 23
        },
        "escalation": {
            "acknowledging": 3,
            "call-out": 3,
            "escalation": 0,
            "handover": 3,
            "questioning": 0,
            "task allocation": 3
        },
        "handover": {
            "acknowledging": 13,
            "call-out": 12,
            "escalation": 3,
            "handover": 0,
            "questioning": 4,
            "task allocation": 9
        },
        "questioning": {
            "acknowledging": 18,
            "call-out": 17,
            "escalation": 0,
            "handover": 4,
            "questioning": 0,
            "task allocation": 16
        },
        "task allocation": {
            "acknowledging": 24,
            "call-out": 23,
            "escalation": 3,
            "handover": 9,
            "questioning": 16,
            "task allocation": 0
        }
    },
    "status": 200,
    "statusText": "OK",
    "headers": {
        "content-length": "755",
        "content-type": "application/json"
    },
    "config": {
        "transitional": {
            "silentJSONParsing": true,
            "forcedJSONParsing": true,
            "clarifyTimeoutError": false
        },
        "transformRequest": [
            null
        ],
        "transformResponse": [
            null
        ],
        "timeout": 0,
        "xsrfCookieName": "XSRF-TOKEN",
        "xsrfHeaderName": "X-XSRF-TOKEN",
        "maxContentLength": -1,
        "maxBodyLength": -1,
        "env": {
            "FormData": null
        },
        "headers": {
            "Access-Control-Allow-Origin": "http://localhost"
        },
        "baseURL": "http://localhost:5003",
        "method": "get",
        "url": "/get_ena_data?sessionId=417&start=562&end=794"
    },
    "request": {}
}`;
  const doctorResponse = `{
    "data": {
        "acknowledging": {
            "acknowledging": 0,
            "call-out": 91,
            "escalation": 3,
            "handover": 17,
            "questioning": 67,
            "task allocation": 78
        },
        "call-out": {
            "acknowledging": 91,
            "call-out": 0,
            "escalation": 3,
            "handover": 17,
            "questioning": 59,
            "task allocation": 64
        },
        "escalation": {
            "acknowledging": 3,
            "call-out": 3,
            "escalation": 0,
            "handover": 0,
            "questioning": 2,
            "task allocation": 2
        },
        "handover": {
            "acknowledging": 17,
            "call-out": 17,
            "escalation": 0,
            "handover": 0,
            "questioning": 7,
            "task allocation": 10
        },
        "questioning": {
            "acknowledging": 67,
            "call-out": 59,
            "escalation": 2,
            "handover": 7,
            "questioning": 0,
            "task allocation": 53
        },
        "task allocation": {
            "acknowledging": 78,
            "call-out": 64,
            "escalation": 2,
            "handover": 10,
            "questioning": 53,
            "task allocation": 0
        }
    },
    "status": 200,
    "statusText": "OK",
    "headers": {
        "content-length": "757",
        "content-type": "application/json"
    },
    "config": {
        "transitional": {
            "silentJSONParsing": true,
            "forcedJSONParsing": true,
            "clarifyTimeoutError": false
        },
        "transformRequest": [
            null
        ],
        "transformResponse": [
            null
        ],
        "timeout": 0,
        "xsrfCookieName": "XSRF-TOKEN",
        "xsrfHeaderName": "X-XSRF-TOKEN",
        "maxContentLength": -1,
        "maxBodyLength": -1,
        "env": {
            "FormData": null
        },
        "headers": {
            "Access-Control-Allow-Origin": "http://localhost"
        },
        "baseURL": "http://localhost:5003",
        "method": "get",
        "url": "/get_ena_data?sessionId=417&start=794&end=1391"
    },
    "request": {}
}`;
  let resResponse; // Declare resResponse outside the switch

  // Create a condition key for switch
  const conditionKey = `${simulationId}-${startTime}-${endTime}`;

  switch (conditionKey) {
    case "417-0-1391":
      resResponse = allResponse;
      break;
    case "417-190-431":
      resResponse = scnStartedResponse;
      break;
    case "417-431-562":
      resResponse = handoverResponse;
      break;
    case "417-562-794":
      resResponse = secondaryResponse;
      break;
    case "417-794-1391":
      resResponse = doctorResponse;
      break;
    default:
      resResponse = allResponse;
      break;
  }

  return JSON.parse(resResponse);
};

const getTeamworkBarchart = async (body) => {
  const { simulationId, startTime, endTime } = body;

  // Hard coded data for session 350
  const allResponse = `{
    "data": [{"label":["Working together","on tasks for Ruth"],"value":20.304315290596158},{"label":["Working individually","on tasks for Ruth"],"value":28.23646794711898},{"label":["Working together","on other tasks"],"value":13.644300324270391},{"label":["Working individually","on other tasks"],"value":6.784734347717636},{"label":["Moving around","the beds"],"value":31.030182090296833}]
,
    "status": 200,
    "statusText": "OK",
    "headers": {
        "content-length": "376",
        "content-type": "application/json"
    },
    "config": {
        "transitional": {
            "silentJSONParsing": true,
            "forcedJSONParsing": true,
            "clarifyTimeoutError": false
        },
        "transformRequest": [
            null
        ],
        "transformResponse": [
            null
        ],
        "timeout": 0,
        "xsrfCookieName": "XSRF-TOKEN",
        "xsrfHeaderName": "X-XSRF-TOKEN",
        "maxContentLength": -1,
        "maxBodyLength": -1,
        "env": {
            "FormData": null
        },
        "headers": {
            "Access-Control-Allow-Origin": "http://localhost"
        },
        "baseURL": "http://localhost:5003",
        "method": "get",
        "url": "/get_teamwork_prio_data?sessionId=417&start=0&end=1391"
    },
    "request": {}
}`;
  const scnStartedResponse = `{
    "data": [{"label":["Working together","on tasks for Ruth"],"value":2.6666666666666665},{"label":["Working individually","on tasks for Ruth"],"value":18.8},{"label":["Working together","on other tasks"],"value":10.0},{"label":["Working individually","on other tasks"],"value":14.933333333333335},{"label":["Moving around","the beds"],"value":53.6}]
,
    "status": 200,
    "statusText": "OK",
    "headers": {
        "content-length": "351",
        "content-type": "application/json"
    },
    "config": {
        "transitional": {
            "silentJSONParsing": true,
            "forcedJSONParsing": true,
            "clarifyTimeoutError": false
        },
        "transformRequest": [
            null
        ],
        "transformResponse": [
            null
        ],
        "timeout": 0,
        "xsrfCookieName": "XSRF-TOKEN",
        "xsrfHeaderName": "X-XSRF-TOKEN",
        "maxContentLength": -1,
        "maxBodyLength": -1,
        "env": {
            "FormData": null
        },
        "headers": {
            "Access-Control-Allow-Origin": "http://localhost"
        },
        "baseURL": "http://localhost:5003",
        "method": "get",
        "url": "/get_teamwork_prio_data?sessionId=417&start=190&end=431"
    },
    "request": {}
}`;
  const handoverResponse = `{
    "data": [{"label":["Working together","on tasks for Ruth"],"value":15.488215488215488},{"label":["Working individually","on tasks for Ruth"],"value":47.81144781144781},{"label":["Working together","on other tasks"],"value":0.0},{"label":["Working individually","on other tasks"],"value":0.0},{"label":["Moving around","the beds"],"value":36.7003367003367}]
,
    "status": 200,
    "statusText": "OK",
    "headers": {
        "content-length": "349",
        "content-type": "application/json"
    },
    "config": {
        "transitional": {
            "silentJSONParsing": true,
            "forcedJSONParsing": true,
            "clarifyTimeoutError": false
        },
        "transformRequest": [
            null
        ],
        "transformResponse": [
            null
        ],
        "timeout": 0,
        "xsrfCookieName": "XSRF-TOKEN",
        "xsrfHeaderName": "X-XSRF-TOKEN",
        "maxContentLength": -1,
        "maxBodyLength": -1,
        "env": {
            "FormData": null
        },
        "headers": {
            "Access-Control-Allow-Origin": "http://localhost"
        },
        "baseURL": "http://localhost:5003",
        "method": "get",
        "url": "/get_teamwork_prio_data?sessionId=417&start=431&end=562"
    },
    "request": {}
}`;
  const secondaryResponse = `{
    "data": [{"label":["Working together","on tasks for Ruth"],"value":36.953455571227074},{"label":["Working individually","on tasks for Ruth"],"value":27.644569816643155},{"label":["Working together","on other tasks"],"value":18.758815232722142},{"label":["Working individually","on other tasks"],"value":5.923836389280676},{"label":["Moving around","the beds"],"value":10.719322990126939}]
,
    "status": 200,
    "statusText": "OK",
    "headers": {
        "content-length": "379",
        "content-type": "application/json"
    },
    "config": {
        "transitional": {
            "silentJSONParsing": true,
            "forcedJSONParsing": true,
            "clarifyTimeoutError": false
        },
        "transformRequest": [
            null
        ],
        "transformResponse": [
            null
        ],
        "timeout": 0,
        "xsrfCookieName": "XSRF-TOKEN",
        "xsrfHeaderName": "X-XSRF-TOKEN",
        "maxContentLength": -1,
        "maxBodyLength": -1,
        "env": {
            "FormData": null
        },
        "headers": {
            "Access-Control-Allow-Origin": "http://localhost"
        },
        "baseURL": "http://localhost:5003",
        "method": "get",
        "url": "/get_teamwork_prio_data?sessionId=417&start=562&end=794"
    },
    "request": {}
}`;
  const doctorResponse = `{
    "data":[{"label":["Working together","on tasks for Ruth"],"value":23.546511627906977},{"label":["Working individually","on tasks for Ruth"],"value":31.686046511627907},{"label":["Working together","on other tasks"],"value":16.424418604651162},{"label":["Working individually","on other tasks"],"value":5.717054263565891},{"label":["Moving around","the beds"],"value":22.625968992248062}]
,
    "status": 200,
    "statusText": "OK",
    "headers": {
        "content-length": "381",
        "content-type": "application/json"
    },
    "config": {
        "transitional": {
            "silentJSONParsing": true,
            "forcedJSONParsing": true,
            "clarifyTimeoutError": false
        },
        "transformRequest": [
            null
        ],
        "transformResponse": [
            null
        ],
        "timeout": 0,
        "xsrfCookieName": "XSRF-TOKEN",
        "xsrfHeaderName": "X-XSRF-TOKEN",
        "maxContentLength": -1,
        "maxBodyLength": -1,
        "env": {
            "FormData": null
        },
        "headers": {
            "Access-Control-Allow-Origin": "http://localhost"
        },
        "baseURL": "http://localhost:5003",
        "method": "get",
        "url": "/get_teamwork_prio_data?sessionId=417&start=794&end=1391"
    },
    "request": {}
}`;
  let resResponse; // Declare resResponse outside the switch

  // Create a condition key for switch
  const conditionKey = `${simulationId}-${startTime}-${endTime}`;

  switch (conditionKey) {
    case "417-0-1391":
      resResponse = allResponse;
      break;
    case "417-190-431":
      resResponse = scnStartedResponse;
      break;
    case "417-431-562":
      resResponse = handoverResponse;
      break;
    case "417-562-794":
      resResponse = secondaryResponse;
      break;
    case "417-794-1391":
      resResponse = doctorResponse;
      break;
    default:
      resResponse = allResponse;
      break;
  }

  return JSON.parse(resResponse);
};

export { getSNAdata, getENAdata, getTeamworkBarchart };
